import errorService from 'src/services/error';
import store from 'src/store';
import NotificationsHandler from './NotificationsHandler';

export default class WebNotificationsHandler extends NotificationsHandler {
  /**
   * Adds an event lister to check permissions after window is focused.
   */
  static init() {
    window.addEventListener('focus', () => {
      this.check();
    });
  }

  /**
   * Returns the notification permissions state.
   *
   * @returns {'DEFAULT' | 'DENIED' | 'GRANTED' | null}
   */
  static getNotificationState() {
    if (!window.Notification) {
      return null;
    }
    return window.Notification.permission.toUpperCase();
  }

  /**
   * Requests permission to allow web notifications.
   */
  static request() {
    window.Notification.requestPermission((status) => {
      if (window.Notification.permission !== status) {
        // avoid read-only error in Edge
        try {
          window.Notification.permission = status;
        } catch (error) {
          errorService.log(error);
        }
      }
      store().dispatch('notifications/setNotificationSupport', status.toUpperCase());
    });
  }
}
